import { useTranslation } from 'react-i18next';
import { Alert } from '@/components/ui/Alert';
import { FormField } from '@/components/ui/FormField';
import { Select } from '@/components/ui/Select';
import { useBranch } from '@/hooks/useBranch';

/** Asks which branch to work in when none is active, and chooses nothing on its own: a queue belongs to one branch. */
export function BranchRequired({ message, label }: { message: string; label: string }) {
  const { t } = useTranslation();
  const { branches, selectBranch } = useBranch();

  return (
    <div className="border-line space-y-3 rounded-xl border bg-white px-4 py-4">
      <Alert tone="warning">{message}</Alert>
      {branches.length > 0 ? (
        <FormField label={label} required>
          {({ id, describedBy }) => (
            <Select
              id={id}
              aria-describedby={describedBy}
              value=""
              placeholder={t('opticalOrders.builder.chooseBranchPlaceholder')}
              options={branches.map((branch) => ({
                value: branch.id,
                label: `${branch.name} (${branch.code})`,
              }))}
              onChange={(event) => selectBranch(event.target.value)}
            />
          )}
        </FormField>
      ) : null}
    </div>
  );
}
